import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/plan/querySpringbackPage";
/*获取列表*/
export function saveManyMession(data) {
  return request({
    url: "/icps/system/sign/intelligent/concrete/saveManyMession",
    method: "post",
    data,
  });
}
